import { api, ApiRes } from './client'
import { BankAccountStatus } from '../../typings'

interface PutBankAccountUpdateBody {
    holder?: string
    iban?: string
    bic?: string | null
    is_primary?: boolean
}

interface PostBankAccountBody {
    holder: string
    iban: string
    bic?: string | null
}

export interface FrontendBankAccountResource {
    id: string
    holder: string
    iban: string
    bic: string | null
    status: BankAccountStatus
    primary_for_platforms: string[]
    created_at: string
}

export const getBankAccountsForNaturalProfile = (naturalProfileUid): ApiRes<FrontendBankAccountResource[]> =>
    api.get(`natural-profiles/${naturalProfileUid}/bank-accounts`)

export const getBankAccountsForLegalProfile = (legalProfileUid): ApiRes<FrontendBankAccountResource[]> =>
    api.get(`legal-profiles/${legalProfileUid}/bank-accounts`)

export const postBankAccountForNaturalProfile = (
    naturalProfileUid: string,
    body: PostBankAccountBody
): ApiRes<FrontendBankAccountResource> => api.post(`natural-profiles/${naturalProfileUid}/bank-accounts`, body)

export const postBankAccountForLegalProfile = (
    legalProfileUid: string,
    body: PostBankAccountBody
): ApiRes<FrontendBankAccountResource> => api.post(`legal-profiles/${legalProfileUid}/bank-accounts`, body)

export const putBankAccountUpdate = (
    bankAccountUid: string,
    body: PutBankAccountUpdateBody
): ApiRes<FrontendBankAccountResource> => api.put(`bank-accounts/${bankAccountUid}`, body)

export const deleteBankAccount = (bankAccountUid: string): ApiRes<null> => api.delete(`bank-accounts/${bankAccountUid}`)
